import React, { memo } from 'react';
import { Box } from '@material-ui/core';
import { FormControlType } from '../../../model/global';
import SelectBox from '../SelectBox';
import InputBox from '../InputBox';
import CheckBox from '../CheckBox';

export interface CustomFormFieldState<V = any> {
	name: string;
	value: V;
	required: boolean;
	valid: boolean;
	invalidReason: string;
	// dirty: boolean;
	checked?: boolean;
	options?: any[];
	originalField: FormControlType;
	fileDetails?: {
		fileName: string;
		fileSize: number;
		fileType: string;
		fileIndex: number;
		lastModified: number;
	};
}
interface Props {
	// field: FormControlType;
	field: CustomFormFieldState;
	onFieldChange: (event: CustomFormFieldState) => void;
	fieldErrors: Record<string, string>;
}
const CustomFormField: React.FC<Props> = ({ field, fieldErrors, onFieldChange }) => {
	// extract field error for this field, if exists
	const fieldError = fieldErrors[field.name] || '';

	const renderFormField = (field: CustomFormFieldState): JSX.Element | undefined => {
		switch (field.originalField.fieldType) {
			case 'textarea': // todo? TextField?
			case 'text':
			case 'email': {
				return (
					<InputBox
						field={field}
						onChange={onFieldChange}
						validationError={fieldError}
					/>
				)
			}
			case 'checkbox': {
				return (
					<CheckBox
						field={field}
						onChange={onFieldChange}
						validationError={fieldError}
					/>
				)
			}
			case 'select': {
				return (
					<SelectBox
						field={field}
						onChange={onFieldChange}
						fullWidth={true}
						validationError={fieldError}
					/>
				)
			}
			default: break;
		}
	}

	const respWidthDefault = field.originalField.responsiveWidth?.default || '';
	const respWidthDesktop = field.originalField.responsiveWidth?.desktop || '';

	const customClasses: string = [
		respWidthDefault ? 'uk-width-' + respWidthDefault : '',
		respWidthDesktop ? 'uk-width-' + respWidthDesktop + '@s' : '',
	].filter(c => c).join(' ')

	return <Box className={customClasses} margin={0} sx={{
		// marginTop: 32,// match existing form margin styles
		marginTop: 48,// match existing form margin styles
	}}>
		{renderFormField(field) || null}
	</Box>
};

export default memo(CustomFormField);
